import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  news: NewsItem;
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ news, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/detail/${news.id}`}
        className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
      >
        <div className="w-28 h-20 sm:w-36 sm:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={news.cover}
            alt={`${news.title} 配图`}
            title={`${news.title} - 51动漫`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-[11px] font-medium">
              {news.category}
            </span>
            <span className="text-[11px] text-foreground-500">{news.date}</span>
          </div>
          <h3 className="font-heading font-semibold text-sm text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {news.title}
          </h3>
          <p className="mt-1.5 text-xs text-foreground-600 line-clamp-1 hidden sm:block">
            {news.summary}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${news.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="w-full aspect-[16/9] overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`${news.title} 配图`}
          title={`${news.title} - 51动漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-[11px] font-medium">
            {news.category}
          </span>
          <span className="text-[11px] text-foreground-500">{news.date}</span>
        </div>
        <h3 className="font-heading font-semibold text-base text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {news.summary}
        </p>
        <div className="mt-3 flex items-center gap-1.5 text-[11px] text-foreground-500">
          <i className="ri-user-line"></i>
          <span>{news.author}</span>
        </div>
      </div>
    </Link>
  );
}